import React from 'react'
import { toJS } from 'mobx'
import { ConfigProvider, Menu } from 'antd'
import { observer } from 'mobx-react-lite'
import { useStores } from '../../../cls/stores/MobXProvider'
import {
	routesSide,
	routesPages,
	flattenRoutesList,
	routeLanguage
} from '../../../config/routes'
import { FileSearchOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import { validateRoute } from '../../../config/routes-utils'

const NavBarSide = observer(({ collapsed, setCollapsed }) => {
	const stores = useStores()
	const { tourStore } = stores

	// Trigger update when collapsed change
	React.useEffect(() => {
		setCollapsed(collapsed)
	}, [collapsed])

	const items = []

	// Add language selector to the sidebar
	items.push(validateRoute(routeLanguage[0], stores, collapsed))

	routesSide.forEach((route) => {
		const validItem = validateRoute(route, stores, collapsed)
		items.push(validItem)
	})

	const collectExpandableKeys = (menuItems) => {
		let keys = []

		menuItems.forEach((item) => {
			if (item?.children) {
				keys.push(item.key)
				keys = keys.concat(item.children.map((child) => child.key))
			}
		})

		return keys
	}

	tourStore.sidebarKeys = collectExpandableKeys(items)

	// console.log('Collected Sidebar Keys:', tourStore.sidebarKeys)

	const pages = validateRoute(
		{
			key: 'pages',
			id: 'menu-pages',
			label: 'single.pages',
			icon: FileSearchOutlined,
			collapsedTitle: true,
			children: routesPages
		},
		stores,
		collapsed
	)
	items.push(pages)

	const searchKeySelected = (curentPage) => {
		const route = flattenRoutesList.find((r) => r.key === curentPage)
		if (!route) return []

		if (route?.keyparent) {
			return [route.keyparent, route.key]
		}
		return [route.key]
	}

	const curentSelectedMenuItem = () => {
		const path = window.location.pathname
		const firstSegment = path.split('/')[1] // Split the path and get the first segment
		const curentPage = firstSegment ? firstSegment : 'home' // Return the first segment or '/' if it doesn't exist
		return searchKeySelected(curentPage)
	}

	const [selectedMenuItem, setSelectedMenuItem] = React.useState(
		curentSelectedMenuItem()
	)

	return (
		<ConfigProvider
			theme={{
				components: {
					Menu: {
						itemHeight: '30px',
						itemBorderRadius: 4,
						itemSelectedBg: 'unset',
						itemPaddingInline: 0
					}
				}
			}}
		>
			<Menu
				mode="inline"
				openKeys={toJS(tourStore.menusExpanded)}
				onOpenChange={(openKeys) => {
					tourStore.setMenusExpanded(openKeys)
				}}
				triggerSubMenuAction="click"
				ref={React.createRef()}
				id="side-menu"
				inlineIndent={0}
				items={items}
				selectedKeys={selectedMenuItem}
				onClick={(e) => {
					setSelectedMenuItem(searchKeySelected(e.key))
					isMobile && setCollapsed(true)
				}}
			/>
		</ConfigProvider>
	)
})

NavBarSide.propTypes = {
	setCollapsed: PropTypes.func
}

export default NavBarSide
